<template>
  <teleport to="body">
    <transition name="bm" appear>
      <div v-if="modelValue" class="bm" @keydown.esc.window.prevent="close">
        <div class="bm__background" @click="close">
          <div class="bm__container" @click.stop>
            <!-- Header слот -->
            <div v-if="$slots.header" class="bm__header">
              <slot name="header" />
            </div>

            <!-- Основной контент -->
            <div class="bm__body">
              <slot />
            </div>

            <!-- Footer слот -->
            <div v-if="$slots.footer" class="bm__footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "BottomModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  }
};
</script>

<style scoped>
.bm-close__svg {
	width: 2rem;
	height: 2rem;	
}

.bm {
	position: fixed;
	bottom: 2rem;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1000;
}

.bm__background {

}

.bm__container {
  width: 100%;
	background-color: var(--grey-0);
  border-radius: 0.5rem;
  position: relative;
  box-sizing: border-box;
  z-index: 1;
  display: flex;
  flex-direction: row;
	align-items: center;
}

/* Кнопка закрытия */
.bm__close {
  position: absolute;
	top: 0.8rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text);
  transition: all 0.3s ease;
}
.bm__close:hover {
  color: var(--grey-0);
}

.bm__header {
  font-weight: bold;
  padding: 1rem;
  text-align: left;
}
.bm__body {
  flex: 1;
	padding: 1rem;
  overflow-y: auto;
}
.bm__footer {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1rem;
  height: fit-content;
}

/* Адаптивность */
@media (min-width: 40rem) { /* 640px */
  .bm__container {
    width: 80%;
    max-width: 43.75rem; /* 700px */
  }
}

@media (min-width: 64rem) { /* 1024px */
  .bm__container {
    width: 100%;
    max-width: 75rem; /* 1200px */
  }
}

/* Transition для анимации */
.bm-enter-active .bm__background,
.bm-leave-active .bm__background {
  transition: opacity 0.3s ease;
}
.bm-enter-from .bm__background,
.bm-leave-to .bm__background {
  opacity: 0;
}

.bm-enter-active .bm__container,
.bm-leave-active .bm__container {
  transition: transform 0.3s cubic-bezier(.2,.8,.2,1), opacity 0.22s ease;
}
.bm-enter-from .bm__container,
.bm-leave-to .bm__container {
  transform: translateY(-0.75rem) scale(0.98);
  opacity: 0;
}
</style>
